import { JobRefreshParameters } from './longRunningTasksApi'

export const TaskTypes = ['job-refresh'] as const

export type TaskType = (typeof TaskTypes)[number]

export type TaskTypeDefinition = {
  label: string
  description: string
}

export const taskTypeDefinitions: Record<TaskType, TaskTypeDefinition> = {
  'job-refresh': {
    label: 'Job refresh',
    description: 'Refreshes jobs, optionally limited to one tenant, a job ID range or a maximum number of jobs.',
  },
}

export const getTaskTypeLabel = (type: string): string => {
  return taskTypeDefinitions[type as TaskType]?.label ?? type
}

export type JobRefreshFormValues = {
  tenantId?: number | null
  startJobId?: number | null
  endJobId?: number | null
  maxJobs?: number | null
}

export const defaultJobRefreshFormValues = (): JobRefreshFormValues => ({
  tenantId: undefined,
  startJobId: undefined,
  endJobId: undefined,
  maxJobs: undefined,
})

export const toJobRefreshParameters = (values: JobRefreshFormValues): JobRefreshParameters => ({
  tenantId: values.tenantId ?? null,
  startJobId: values.startJobId ?? null,
  endJobId: values.endJobId ?? null,
  maxJobs: values.maxJobs ?? null,
})

export type CreateTaskRequest =
  | { type: 'job-refresh', values: JobRefreshFormValues }

export const defaultFormValues = (type: TaskType): CreateTaskRequest['values'] => {
  switch (type) {
    case 'job-refresh':
      return defaultJobRefreshFormValues()
  }
}

export const toCreateTaskRequest = <T extends TaskType>(
  type: T,
  values: Extract<CreateTaskRequest, { type: T }>['values'],
): CreateTaskRequest => ({ type, values } as CreateTaskRequest)
